module.exports = __webpack_public_path__ + "img/step.dc1e92f9.png";